<template>
  <div class="login-container">
    <van-image class="title" fit="contain" :src="titleUrl" />
    <div class="login-form">
      <p class="login-text">登录/注册</p>
      <div class="login-info">
        <div class="info-item">
          <div class="item-line">
            <i class="iconfont icon-mobile-phone"></i>
            <p class="item-text">手机号码</p>
            <input type="number" v-model="phone" placeholder="请输入手机号码" />
          </div>
        </div>
        <div class="info-item">
          <div class="item-line">
            <i class="iconfont icon-security"></i>
            <p class="item-text">验证码</p>
            <input
              type="text"
              placeholder="输入验证码"
              v-model="code"
              maxlength="6"
            />
          </div>
          <div class="send-code" @click="sendSms">{{
            sendTime ? sendTime + 's' : '发送验证码'
          }}</div>
        </div>
      </div>
      <div class="check-box">
        <van-checkbox v-model="checked" shape="square" checked-color="#ff5a5a">
          <p class="protocol"
            ><span>已阅读并同意</span
            ><span class="black">《用户隐私协议》</span></p
          >
        </van-checkbox>
      </div>
      <div class="login-btn" @click="login">登录</div>
    </div>
    <p class="text">WEGYMER <span class="name">@健萌智训</span></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bgUrl:
        'https://cdnvue.gymcity.com.cn/uploads/51f1e4a2cc4fba4a49d6d68880a69d3c.png',
      personUrl:
        'https://cdnvue.gymcity.com.cn/uploads/b7cbc127e81a99f5cd304d9609ba7538.png',
      titleUrl:
        'https://cdnvue.gymcity.com.cn/uploads/4e3b80cf3586a480b7f039432e92a02f.png',
      checked: false,
      disabledSend: false, //是否禁用发送短信按钮
      sendTime: '',
      phone: '',
      code: ''
    }
  },
  created() {},
  methods: {
    sendSms() {
      if (this.disabledSend) {
        return
      }
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      let params = {
        phone: this.phone
      }
      this.$http
        .getApp('member/StorageLogin/sendSms', params)
        .then((res) => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            this.$toast('发送成功')
            this.sendTime = 60
            this.disabledSend = true
            this.timer = setInterval(() => {
              if (this.sendTime > 0) {
                this.sendTime--
              } else {
                this.disabledSend = false
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    },
    login() {
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      if (!this.code) {
        this.$toast('验证码不能为空')
      }
      this.httpLogin()
    },
    httpLogin() {
      let params = {
        phone: this.phone,
        code: this.code
      }
      this.$http
        .getApp('member/StorageLogin/loginRegister', params)
        .then((res) => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            this.$toast('登录成功')
            localStorage.setItem('storageToken', res.data.storage_token)
            setTimeout(() => {
              // this.$router.push("/fatcamp/home");
              this.$router.go(-1)
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    }
  }
}
</script>
<style lang="scss">
.login-container {
  .van-icon {
    border-radius: 1.1vw;
    overflow: hidden;
  }
}
</style>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  background-position: center;
  background-image: url('https://cdnvue.gymcity.com.cn/uploads/51f1e4a2cc4fba4a49d6d68880a69d3c.png');
  .title {
    width: 76.5vw;
    flex: 1;
    margin-top: 9vw;
    flex-shrink: 0;
    overflow: hidden;
  }
  .login-form {
    width: 89.3vw;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 2.7vw;
    margin-bottom: 6.4vw;
    padding: 5.3vw 6.5vw;
    text-align: left;
    .login-text {
      line-height: 7.5vw;
      font-family: PingFangSC-Medium;
      font-size: 5.3vw;
      color: #000000;
      font-weight: 600;
      margin-bottom: 3.2vw;
    }
    .protocol {
      font-family: PingFangSC-Regular;
      font-size: 3.2vw;
      line-height: 4.3vw;
      color: #878787;
    }
    .black {
      font-family: PingFangSC-Medium;
      color: #000;
      font-weight: 600;
    }
    .check-box {
      margin-bottom: 5.1vw;
    }
    .login-info {
      margin-bottom: 5.3vw;
      .info-item {
        height: 13.9vw;
        display: flex;
        align-items: flex-end;
        .item-line {
          height: 100%;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #f1f1f1;
        }
        .iconfont {
          color: rgb(179, 179, 179);
        }
        .item-text {
          width: 15vw;
          margin: 0vw 2.7vw;
          font-family: PingFangSC-Medium;
          font-size: 3.5vw;
          color: rgba(0, 0, 0, 0.7);
        }
        input {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          height: 8vw;
          border: none;
        }
        input::-webkit-input-placeholder {
          font-size: 3.5vw;
          font-stretch: normal;
          line-height: 8vw;
          color: rgba(0, 0, 0, 0.3);
        }
      }
      .send-code {
        text-align: center;
        width: 22.1vw;
        height: 10.4vw;
        line-height: 10.4vw;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        background-color: #ffffff;
        border-radius: 1.6vw;
        border: solid 0.3vw #e7e7e7;
        font-family: PingFangSC-Regular;
        font-size: 3.2vw;
        color: #000;
        margin-left: 2.9vw;
      }
    }
    .login-btn {
      text-align: center;
      height: 10.7vw;
      line-height: 10.7vw;
      background-color: #ff5a5a;
      box-shadow: 0vw 1.3vw 2.1vw 0vw rgba(0, 0, 0, 0.1);
      border-radius: 2.7vw;
      font-family: PingFangSC-Medium;
      font-size: 4vw;
      color: #fff;
      margin-bottom: 6.7vw;
    }
  }
  .text {
    font-family: PingFangSC-Regular;
    font-size: 3.2vw;
    color: #ffffff;
    margin-bottom: 4.1vh;
    .name {
      font-family: PingFangSC-Medium;
    }
  }
}
</style>
